/* ==========================================================================
   Orvo — solar.js
   Loaded only on the solar light template, after cut.js. cut.js runs the
   gallery, the pack selection, the sticky bar and the accordions; this file
   adds what the solar page has on top:

   - the price under the title and in the sticky bar always show ONE lamp
     (rendered by Liquid; nothing is formatted here);
   - the cart line: the selected pack's own variant, quantity 1
     (the packs are variants with fixed prices per market).

   Cart writes go through window.OrvoAddToCart (theme.js), so the drawer, the
   free-shipping meter and the cross-sell row behave as everywhere else.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-sl-root]');
  if (!root) return;

  var baseId = parseInt(root.getAttribute('data-base-id'), 10) || 0;

  function currentBox() {
    return root.querySelector('[data-kp-tier].is-selected') || root.querySelector('[data-kp-tier]');
  }

  function paint() {
    var box = currentBox();
    if (!box) return;
    // cut.js keeps aria-pressed in step; the packs are a radio group, so mirror it.
    Array.prototype.forEach.call(root.querySelectorAll('[data-kp-tier-head]'), function (h) {
      h.setAttribute('aria-checked', h.closest('[data-kp-tier]') === box ? 'true' : 'false');
    });
  }

  // cut.js selects the pack in its own (earlier) listener; repaint right after it.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-kp-tier-head]') || e.target.closest('[data-kp-jump]')) setTimeout(paint, 0);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sl-add]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    var box = currentBox();
    if (!box) return;
    var vid = parseInt(box.getAttribute('data-variant-id'), 10) || 0;
    var items = vid ? [{ id: vid, quantity: 1 }] : [{ id: baseId, quantity: parseInt(box.getAttribute('data-units'), 10) || 1 }];
    if (!items[0].id) return;
    btn.classList.add('is-shine');
    setTimeout(function () { btn.classList.remove('is-shine'); }, 1200);
    if (window.OrvoAddToCart) window.OrvoAddToCart(items, btn);
    else window.location.href = (((window.Orvo || {}).routes || {}).cart_url) || '/cart';
  });

  paint();
})();

/* Photo grid: Enter/Space on the zoom button opens the shared lightbox (cut.js listens on the img). */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sl-zoom]');
    if (!btn || e.target !== btn) return;
    var img = btn.querySelector('img');
    if (img) img.click();
  });
})();
